"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./SelectedPlanSubItem.css");
require("./SelectedPlanSubItem.tablet.css");
var Label_1 = require("../../atoms/Label/Label");
var PriceContainer_1 = require("../../cards/PriceContainer/PriceContainer");
var PriceContainerProps_1 = require("../../cards/PriceContainer/PriceContainerProps");
var utils_1 = require("../../../utils/utils");
var LabelProps_1 = require("../../atoms/Label/LabelProps");
var Link_1 = require("../../atoms/Link");
var TooltipProps_1 = require("../../atoms/Tooltip/TooltipProps");
var Tooltip_1 = require("../../atoms/Tooltip/");
var ChangeText = 'Change';
var RemoveText = 'Remove';
var SelectedPlanSubItem = /** @class */ (function (_super) {
    __extends(SelectedPlanSubItem, _super);
    function SelectedPlanSubItem(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeEvents();
        return _this;
    }
    SelectedPlanSubItem.prototype.render = function () {
        var pricingType = (window.innerWidth < 768) ? PriceContainerProps_1.PricingType.XSMALL : PriceContainerProps_1.PricingType.SMALL;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.contentItem },
            React.createElement("div", { className: styles.contentText },
                React.createElement(Label_1.default, { testId: utils_1.default('Label', 'SubItemTitlePrice'), data: { isDecodingRequired: false, text: this.props.data.title }, options: __assign({ className: styles.planSubtitle }, (this.props.options ? this.props.options : {})) }),
                this.props.data.toolTipData &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Tooltip_1.default, { data: { type: TooltipProps_1.TooltipTypes.INLINE } },
                            React.createElement(Label_1.default, { data: { isDecodingRequired: false, text: this.props.data.toolTipData }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } }))),
                this.getButtons()),
            !this.props.data.hidePrice &&
                React.createElement(React.Fragment, null,
                    this.props.data.discountedPrice &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.strikePrice },
                                React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'SubItemPriceContainer'), data: this.props.data.price, options: { type: pricingType, decimalPoints: 2 } })),
                            React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'SubItemPriceContainer'), data: this.props.data.discountedPrice, options: { type: pricingType, className: styles.planSubtitle, decimalPoints: 2 } })),
                    !this.props.data.discountedPrice &&
                        React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'SubItemPriceContainer'), data: this.props.data.price, options: { className: styles.planSubtitle,
                                customClasses: this.props.options.customClasses, decimalPoints: 2,
                                isDataPriceNegative: this.props.options.isDataPriceNegative, type: pricingType } }))));
    };
    SelectedPlanSubItem.prototype.getButtons = function () {
        return ((this.props.events.onChangeSelected !== undefined
            || this.props.events.onRemoveSelected !== undefined)
            &&
                React.createElement("div", { className: styles.subItemButtonContainer },
                    this.props.events.onChangeSelected !== undefined &&
                        React.createElement(Link_1.default, { testId: utils_1.default('Button', 'SubItemChangePlan'), data: { content: this.props.data.changeLinkLabel || ChangeText }, options: { className: styles.subItemButton }, events: this.changeEvent }),
                    this.props.events.onRemoveSelected !== undefined &&
                        React.createElement(Link_1.default, { testId: utils_1.default('Button', 'SubItemRemovePlan'), data: { content: this.props.data.removeLinkLabel || RemoveText }, options: { className: styles.subItemButton }, events: this.removeEvent })));
    };
    SelectedPlanSubItem.prototype.initializeEvents = function () {
        this.changeEvent = {
            onClick: this.props.events.onChangeSelected,
        };
        this.removeEvent = {
            onClick: this.props.events.onRemoveSelected,
        };
    };
    SelectedPlanSubItem.defaultProps = {
        events: {},
        options: {
            customClasses: {
                minusClass: '',
            },
            isDataPriceNegative: false,
        },
    };
    return SelectedPlanSubItem;
}(React.Component));
exports.default = SelectedPlanSubItem;
//# sourceMappingURL=SelectedPlanSubItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectedPlanSubItem/SelectedPlanSubItem.js
// module id = 838
// module chunks = 8